var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8784B7",
    fillRule: "evenodd",
    d: "M3.464 21.036C4.93 22.5 7.286 22.5 12 22.5s7.071 0 8.535-1.465C22 19.572 22 17.214 22 12.5s0-7.071-1.465-8.536C19.072 2.5 16.714 2.5 12 2.5s-7.071 0-8.536 1.464C2 5.43 2 7.786 2 12.5s0 7.071 1.464 8.535M9.5 9.25a3.25 3.25 0 1 0 3.25 3.25.75.75 0 0 1 1.5 0A4.75 4.75 0 1 1 9.5 7.75a.75.75 0 0 1 0 1.5m8.25 3.25a3.25 3.25 0 0 1-3.25 3.25.75.75 0 0 0 0 1.5 4.75 4.75 0 1 0-4.75-4.75.75.75 0 0 0 1.5 0 3.25 3.25 0 0 1 6.5 0",
    clipRule: "evenodd"
  })));
};
export default SvgLink;